import React, { useMemo } from "react";
import { useTranslation } from 'react-i18next';
import {
  LineChart,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Line,
} from "recharts";
import Months from "../../../Enum/Months";
import '../../../css/Pages.css';

function BerichtenGraph(props) {
  const { t } = useTranslation();
  const monthLabels = useMemo(() => ([
    t('months.january'),
    t('months.february'),
    t('months.march'),
    t('months.april'),
    t('months.may'),
    t('months.june'),
    t('months.july'),
    t('months.august'),
    t('months.september'),
    t('months.october'),
    t('months.november'),
    t('months.december')
  ]), [t]);

  return (
    <div style={{ gridColumn: "span 3" }}>
      <div className="font-bold mb-2">{t('dashboard.messageCountTitle')}</div>
      <div>
        <LineChart
          width={800}
          height={400}
          data={
            props.graphOptions.selectedYear
              ? props.graphOptions.selectedMonth
                ? props.graphOptions.data.filter((obj) => {
                    return (
                      obj.jaar === props.graphOptions.selectedYear &&
                      obj.maand === props.graphOptions.selectedMonth
                    );
                  })
                : props.graphOptions.data.filter((obj) => {
                    return obj.jaar === props.graphOptions.selectedYear;
                  })
              : props.graphOptions.data
          }
          margin={{ top: 5, right: 20, left: 10, bottom: 5 }}
        >
          <XAxis
            tickLine={true}
            xAxisId={0}
            dy={0}
            dx={-0}
            label={{ value: "", angle: 0, position: "bottom" }}
            interval={0}
            dataKey="maand"
            tick={{ fontSize: 9, angle: 0 }}
          />
          <XAxis
            xAxisId={1}
            dy={-15}
            dx={0}
            label={{ value: "", angle: 0, position: "bottom" }}
            interval={10}
            dataKey="jaar"
            tickLine={false}
            tick={{ fontSize: 9, angle: 0 }}
          />
          <YAxis dataKey="aantal" name={t('dashboard.messageCountTitle')} />
          <Tooltip content={<CustomTooltip monthLabels={monthLabels} t={t} />} />
          <CartesianGrid stroke="rgb(var(--chart-grid))" />
          <Line type="monotone" dataKey="aantal" stroke="#ff7300" yAxisId={0} />
        </LineChart>
      </div>
    </div>
  );
}
export default BerichtenGraph;

const CustomTooltip = ({ active, payload, label, monthLabels = [], t }) => {
  if (active && payload && payload.length > 0) {
    return (
      <div className="custom-tooltip">
        <p className="intro">
          {(monthLabels[label - 1] || Months[label - 1]) + " " + payload[0].payload.jaar}
        </p>
        <p className="label">{t('dashboard.messageCountLabel', { count: payload[0].payload.aantal })}</p>
      </div>
    );
  }

  return null;
};
